export default __webpack_public_path__ + "static/media/anneK.ce48eed8.png";